// import "vue-form-generator/dist/vfg-core.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/js/bootstrap.js";
import "./assets/styles/fonts.css";
require("./http/http-common.js");
require("@/plugins/filters.js");
import Vue from "vue";

import FlagIcon from "vue-flag-icon";
import VueGtm from "vue-gtm";
import VueAnalytics from "vue-analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/plugins/language/i18n";
import Cookies from "js-cookie";
// import auth from "@/auth";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faInfoCircle,
	faCalendarAlt,
	faPlusCircle,
	faMinusCircle,
	faArrowAltCircleRight,
	faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Loader from "./components/fragments/Loader";
import LanguageBar from "./components/LanguageBar";
import Multiselect from "vue-multiselect";
import moment from "moment";

library.add(faInfoCircle);
library.add(faCalendarAlt);
library.add(faPlusCircle);
library.add(faMinusCircle);
library.add(faArrowAltCircleRight);
library.add(faChevronLeft);


Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("contentLoader", Loader);
Vue.component("LanguageBar", LanguageBar);
Vue.component("multiselect", Multiselect);

Vue.config.productionTip = false;

// require("./assets/styles/normalize.css");
import httpServiceUser from "@/http/http-user.js";


// Vue.use(auth);
Vue.use(FlagIcon);
Vue.config.productionTip = false;
Vue.mixin({
	methods: {
		scrollToTop(pixels = 0) {
			window.scrollTo({ top: pixels, behavior: "smooth" });
		},
		formatDate(date, format, fromFormat) {
			return moment(date, fromFormat).format(format);
		},

		sendClickToGA(category, action, label) {
			if (this.$ga) {
				this.$ga.event({
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
				});
			}
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		isUserPremium(user) {
			return (
				user.companies[0].role_id === "2" || user.companies[0].role_id === 2 || this.isUserAdmin(user)
			);
		},
		isUserAdmin(user) {
			return (
				user.companies[0].role_id === "3" || user.companies[0].role_id === 3
			);
		},
		isUserMarketing(user) {
			return (
				user.companies[0].role_id === "4" || user.companies[0].role_id === 4
			);
		},

		getImagePath() {
			return (
				"https://api.uponline.ro/upclub/" + ((process.env.NODE_ENV === "development") ? "staging/" : "release/")
			);
		},

		getUser() {

			if (Cookies.get("user_data")) {
				return JSON.parse(Cookies.get("user_data"));
			} else {
				httpServiceUser.userService
					.getUserData(Cookies.get('userLink'), Cookies.get('token'))
					.then((response) => {
						Cookies.set("user_data", response.data, {
							expires: 6000000 / (24 * 60 * 60),
							sameSite: "Strict",
						});
						return response.data;
					});
			}
		},
	},
});

if (!FileReader.prototype.readAsBinaryString) {
	FileReader.prototype.readAsBinaryString = function (fileData) {
		var binary = "";
		var pt = this;
		var reader = new FileReader();
		reader.onload = function () {
			var bytes = new Uint8Array(reader.result);
			var length = bytes.byteLength;
			for (var i = 0; i < length; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			//pt.result  - readonly so assign binary
			pt.content = binary;
			pt.onload();
		};
		reader.readAsArrayBuffer(fileData);
	};
}

new Vue({
	delimiters: ["[[", "]]"],
	router,
	store,
	i18n,
	render: (h) => h(App),
	mounted() {
		const isProd = process.env.NODE_ENV === "production";
		if (Cookies.get("cookies_analytics") !== null) {
			Vue.use(VueGtm, {
				id: "GTM-N2W59PJ", // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
				// queryParams: {
				// 	// Add url query string when load gtm.js with GTM ID (optional)
				// 	gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
				// 	gtm_preview: "env-4",
				// 	gtm_cookies_win: "x"
				// },
				enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
				debug: true, // Whether or not display console logs debugs (optional)
				loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
				vueRouter: router, // Pass the router instance to automatically sync with router (optional)
				// ignoredViews: ["homepage"] // If router, you can exclude some routes name (case insensitive) (optional)
			});
			Vue.use(VueAnalytics, {
				id: "UA-59971354-2",
				router,
				checkDuplicatedScript: true,
				enabled: true,
				debug: {
					enabled: false, // default value
					trace: false, // default value
					sendHitTask: true, // default value
				},
			});
		}
	},
}).$mount("#app");
